(function () {
  var DEFAULT_INTERVAL = 3500;
  // Slightly longer than the 0.5s CSS transition, so the fade is visually
  // finished before the leaving slide snaps back to its resting position.
  var TRANSITION_MS = 600;

  function openPopup(popup) {
    if (!popup) return;
    popup.hidden = false;
    requestAnimationFrame(function () {
      popup.classList.add('is-open');
    });
    document.body.classList.add('m-overlay-popup-open');
    var closeBtn = popup.querySelector('[data-overlay-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closePopup(popup) {
    popup.classList.remove('is-open');
    document.body.classList.remove('m-overlay-popup-open');
    window.setTimeout(function () {
      popup.hidden = true;
    }, 300);
  }

  // Both the body offset and the docked header's top read this, so the bar
  // never lands on the header (or on the search field inside it). The theme
  // measures its own announcement bar into --m-announcement-height and skips
  // it when absent, which is the case here, so the same height also goes there
  // to keep the header's overlays lined up under the bar.
  function syncBarHeight(bar) {
    var height = bar.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--overlay-bar-height', height + 'px');
    document.documentElement.style.setProperty('--m-announcement-height', height + 'px');
  }

  function initBar(bar, popup) {
    var slides = Array.prototype.slice.call(bar.querySelectorAll('[data-overlay-slide]'));

    syncBarHeight(bar);
    if (typeof ResizeObserver !== 'undefined') {
      var heightObserver = new ResizeObserver(function () {
        syncBarHeight(bar);
      });
      heightObserver.observe(bar);
      var inner = bar.querySelector('.m-overlay-bar__inner');
      if (inner) heightObserver.observe(inner);
    } else {
      window.addEventListener('resize', function () {
        syncBarHeight(bar);
      });
    }
    window.addEventListener('load', function () {
      syncBarHeight(bar);
    });

    bar.querySelectorAll('[data-overlay-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openPopup(popup);
      });
    });

    if (slides.length < 2) return;

    var interval = parseFloat(bar.dataset.overlayInterval) || DEFAULT_INTERVAL;
    var current = 0;
    var timer = null;
    var leavingSlide = null;
    var resetTimer = null;

    // Park the slide that is on its way out back at its resting position below
    // the bar. Tracked as state rather than left to a stray timeout so that a
    // click landing mid-transition cannot strip the class off the wrong slide.
    function settleLeavingSlide() {
      if (resetTimer) {
        window.clearTimeout(resetTimer);
        resetTimer = null;
      }
      if (leavingSlide) {
        leavingSlide.classList.remove('is-leaving');
        leavingSlide = null;
      }
    }

    function goTo(index) {
      if (index === current) return;

      var leaving = slides[current];
      var entering = slides[index];

      settleLeavingSlide();

      leaving.classList.remove('is-active');
      leaving.classList.add('is-leaving');
      leaving.setAttribute('aria-hidden', 'true');

      // On rapid clicks the entering slide can be the one that was still fading
      // out, sitting above the bar. Drop its class and force a reflow so the
      // browser commits the resting position first — otherwise the transition
      // starts from wherever the interrupted fade left it and the message
      // appears to drop in from the top.
      entering.classList.remove('is-leaving');
      // eslint-disable-next-line no-unused-expressions
      entering.offsetHeight;
      entering.classList.add('is-active');
      entering.removeAttribute('aria-hidden');

      leavingSlide = leaving;
      resetTimer = window.setTimeout(settleLeavingSlide, TRANSITION_MS);

      current = index;
      requestAnimationFrame(function () {
        syncBarHeight(bar);
      });
    }

    function step(offset) {
      goTo((current + offset + slides.length) % slides.length);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function play() {
      stop();
      if (document.hidden) return;
      timer = window.setInterval(function () {
        step(1);
      }, interval);
    }

    var prev = bar.querySelector('[data-overlay-slide-prev]');
    if (prev) {
      prev.addEventListener('click', function () {
        step(-1);
        play();
      });
    }

    var next = bar.querySelector('[data-overlay-slide-next]');
    if (next) {
      next.addEventListener('click', function () {
        step(1);
        play();
      });
    }

    // Deliberately no pause on hover: the bar spans the full width of the
    // viewport, so a pointer resting anywhere near the top of the page would
    // stop the rotation for as long as it sat there. Keyboard focus still
    // pauses, which is the case that actually needs the reading time.
    bar.addEventListener('focusin', stop);
    bar.addEventListener('focusout', play);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else {
        play();
      }
    });

    play();
  }

  function initPopup(popup) {
    popup.querySelectorAll('[data-overlay-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        closePopup(popup);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !popup.hidden) {
        closePopup(popup);
      }
    });
  }

  function initAll() {
    var popup = document.querySelector('[data-overlay-popup]');

    document.querySelectorAll('[data-overlay-bar]').forEach(function (bar) {
      if (bar.dataset.overlayReady) return;
      bar.dataset.overlayReady = '1';
      initBar(bar, popup);
    });
    if (popup && !popup.dataset.overlayReady) {
      popup.dataset.overlayReady = '1';
      initPopup(popup);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // The theme editor re-renders the section on every change, handing us fresh
  // markup with no listeners and no running timer. The guard above keeps this
  // from binding an already-initialised bar twice.
  document.addEventListener('shopify:section:load', initAll);
})();
